var _defineProperty = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var integration = require('../integration.js');
var metadata = require('../metadata.js');
var envelope = require('../utils-hoist/envelope.js');
var stacktrace = require('../utils-hoist/stacktrace.js');

/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */
var thirdPartyErrorFilterIntegration = integration.defineIntegration(function (options) {
  return {
    name: 'ThirdPartyErrorsFilter',
    setup: function setup(client) {
      // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
      // TODO(lforst): Move this cleanup logic into a more central place in the SDK.
      client.on('beforeEnvelope', function (envelope$1) {
        envelope.forEachEnvelopeItem(envelope$1, function (item, type) {
          if (type === 'event') {
            var event = Array.isArray(item) ? item[1] : undefined;
            if (event) {
              metadata.stripMetadataFromStackFrames(event);
              item[1] = event;
            }
          }
        });
      });
      client.on('applyFrameMetadata', function (event) {
        // Only apply stack frame metadata to error events
        if (event.type) {
          return;
        }
        var stackParser = client.getOptions().stackParser;
        metadata.addMetadataToStackFrames(stackParser, event);
      });
    },
    processEvent: function processEvent(event) {
      var frameKeys = getBundleKeysForAllFramesWithFilenames(event);
      if (frameKeys) {
        var arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
        var behaviourApplies = frameKeys[arrayMethod](function (keys) {
          return !keys.some(function (key) {
            return options.filterKeys.includes(key);
          });
        });
        if (behaviourApplies) {
          var shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
          if (shouldDrop) {
            return null;
          } else {
            event.tags = _objectSpread(_objectSpread({}, event.tags), {}, {
              third_party_code: true
            });
          }
        }
      }
      return event;
    }
  };
});
function getBundleKeysForAllFramesWithFilenames(event) {
  var frames = stacktrace.getFramesFromEvent(event);
  if (!frames) {
    return undefined;
  }
  return frames
  // Exclude frames without a filename since these are likely native code or built-ins
  .filter(function (frame) {
    return !!frame.filename;
  }).map(function (frame) {
    if (frame.module_metadata) {
      return Object.keys(frame.module_metadata).filter(function (key) {
        return key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX);
      }).map(function (key) {
        return key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length);
      });
    }
    return [];
  });
}
var BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';
exports.thirdPartyErrorFilterIntegration = thirdPartyErrorFilterIntegration;